(() => {
  if (customElements.get('nn-box-builder')) return;

  const STORAGE_KEY = 'nn-juice-box';

  const money = (cents) => {
    const value = Number(cents || 0) / 100;
    return value.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD'
    });
  };

  customElements.define(
    'nn-box-builder',
    class NnBoxBuilder extends HTMLElement {

      connectedCallback() {
        if (this._ready) return;
        this._ready = true;

        const dataEl = this.querySelector('[data-nn-builder-json]');

        try {
          this.data = JSON.parse(dataEl ? dataEl.textContent : '{}');
        } catch (err) {
          this.data = { products: [] };
        }

        this.products = (this.data.products || []).reduce((map, product) => {
          map[String(product.variantId)] = product;
          return map;
        }, {});

        this.tiers = (this.data.tiers || [])
          .map((tier) => ({
            qty: Number(tier.qty),
            price: Number(tier.price),
            code: String(tier.code || '').trim()
          }))
          .filter((tier) => tier.qty > 0 && tier.price > 0);

        if (!this.tiers.length) {
          this.tiers = [
            { qty: 6, price: 5999, code: 'NNBOX6' },
            { qty: 12, price: 11899, code: 'NNBOX12' },
            { qty: 18, price: 16999, code: 'NNBOX18' },
            { qty: 24, price: 22499, code: 'NNBOX24' },
            { qty: 30, price: 27499, code: 'NNBOX30' },
            { qty: 42, price: 37999, code: 'NNBOX42' }
          ];
        }

        this.tiers.sort((a, b) => a.qty - b.qty);

        const saved = this.readState();

        const savedTier = Number(
          saved.selectedTier || this.tiers[0].qty
        );

        this.selectedTier =
          this.tiers.find(
            (tier) => tier.qty === savedTier
          ) || this.tiers[0];


        this.state = {
          items: {}
        };


        Object.entries(saved.items || {}).forEach(([id, qty]) => {

          if (
            this.products[id] &&
            Number(qty) > 0
          ) {
            this.state.items[id] = Number(qty);
          }

        });


        this.catalog = this.querySelector('[data-nn-catalog]');
        this.tray = this.querySelector('[data-nn-tray]');


        this.bind();
        this.render();
      }


      readState() {
        try {
          return JSON.parse(
            sessionStorage.getItem(STORAGE_KEY) || '{}'
          );
        } catch (err) {
          return {};
        }
      }


      writeState() {

        sessionStorage.setItem(
          STORAGE_KEY,
          JSON.stringify({
            items: this.state.items,
            selectedTier: this.selectedTier.qty
          })
        );

      }


      totalQty() {

        return Object.values(this.state.items)
          .reduce(
            (sum, qty) => sum + Number(qty || 0),
            0
          );

      }


      getTierForQuantity(quantity) {

        const tier = this.tiers.find(
          (tier) => quantity <= tier.qty
        );

        if (tier) return tier;


        const lastTier =
          this.tiers[this.tiers.length - 1];


        return {
          qty:
            Math.ceil(quantity / 6) * 6,
          price:
            lastTier.price,
          code:
            lastTier.code
        };

      }


      remaining() {

        return Infinity;

      }      bind() {

        this.addEventListener('click', (event) => {

          const tierBtn = event.target.closest('[data-nn-tier-select]');

          if (tierBtn) {
            this.selectTier(
              Number(tierBtn.getAttribute('data-nn-tier-select'))
            );
            return;
          }


          const addBtn = event.target.closest('[data-nn-add]');

          if (addBtn) {
            this.changeQty(
              addBtn.getAttribute('data-nn-add'),
              1
            );
            return;
          }


          const inc = event.target.closest('[data-nn-inc]');

          if (inc) {
            this.changeQty(
              inc.getAttribute('data-nn-inc'),
              1
            );
            return;
          }


          const dec = event.target.closest('[data-nn-dec]');

          if (dec) {
            this.changeQty(
              dec.getAttribute('data-nn-dec'),
              -1
            );
            return;
          }


          const removeBtn =
            event.target.closest('[data-nn-remove]');

          if (removeBtn) {

            this.changeQty(
              removeBtn.getAttribute('data-nn-remove'),
              -999
            );

            return;
          }


          const checkout =
            event.target.closest('[data-nn-checkout]');


          if (checkout && !checkout.disabled) {
            this.checkout();
          }

        });

      }



      selectTier(qty) {

        const tier =
          this.tiers.find(
            (entry) => entry.qty === qty
          );


        if (!tier) return;


        this.selectedTier = tier;


        this.writeState();
        this.render();

      }



      changeQty(variantId, delta) {

        const id = String(variantId);

        const product = this.products[id];


        if (!product || !product.available) return;


        const current =
          Number(this.state.items[id] || 0);


        let next =
          current + Number(delta);


        if (next < 0) next = 0;



        if (next === 0) {

          delete this.state.items[id];

        } else {

          this.state.items[id] = next;

        }



        const total = this.totalQty();


        // Automatically update box size
        this.selectedTier =
          this.getTierForQuantity(total);



        this.writeState();

        this.render();

      }



      subtotal() {

        return Object.entries(this.state.items)
          .reduce(
            (sum, [id, qty]) => {

              const product = this.products[id];

              return sum +
                (product ? product.price * qty : 0);

            },
            0
          );

      }



      render() {

        const total =
          this.totalQty();


        const goal =
          this.selectedTier.qty;


        const ready =
          total >= 6;



        this.querySelectorAll('[data-nn-tier-select]')
          .forEach((el) => {

            const qty =
              Number(
                el.getAttribute('data-nn-tier-select')
              );


            el.classList.toggle(
              'is-selected',
              qty === goal
            );

          });



        this.querySelectorAll('[data-nn-card]')
          .forEach((card) => {


            const id =
              card.getAttribute('data-nn-card');


            const product =
              this.products[id];


            const qty =
              Number(
                this.state.items[id] || 0
              );


            const qtyEl =
              card.querySelector('[data-nn-qty]');


            const addBtn =
              card.querySelector('[data-nn-add]');


            const incBtn =
              card.querySelector('[data-nn-inc]');


            const decBtn =
              card.querySelector('[data-nn-dec]');


            if (qtyEl) {
              qtyEl.textContent = String(qty);
            }


            card.classList.toggle(
              'is-in-box',
              qty > 0
            );


            if (!product?.available) {

              if (addBtn) addBtn.disabled = true;

              if (incBtn) incBtn.disabled = true;

              if (decBtn) decBtn.disabled = true;

              return;

            }



            if (addBtn) {

              addBtn.disabled = false;

              addBtn.textContent =
                qty > 0
                  ? 'Add another'
                  : 'Add 1 to box';

            }



            if (incBtn) {
              incBtn.disabled = false;
            }


            if (decBtn) {
              decBtn.disabled = qty <= 0;
            }


          });



        this.renderTray(
          total,
          goal,
          ready
        );

      }      renderTray(total, goal, ready) {

        const lines =
          Object.entries(this.state.items)
            .filter(([, qty]) => qty > 0);


        const subtotal =
          this.subtotal();


        const boxPrice =
          this.selectedTier.price;


        const linesEl =
          this.querySelector('[data-nn-lines]');


        const emptyEl =
          this.querySelector('[data-nn-empty]');


        const countEl =
          this.querySelector('[data-nn-count]');


        const fill =
          this.querySelector('[data-nn-fill]');


        const checkout =
          this.querySelector('[data-nn-checkout]');


        const hint =
          this.querySelector('[data-nn-hint]');


        const subtotalEl =
          this.querySelector('[data-nn-subtotal]');


        const subtotalLabel =
          this.querySelector('[data-nn-subtotal-label]');


        const minline =
          this.querySelector('[data-nn-minline]');


        const totalEl =
          this.querySelector('[data-nn-total]');



        if (countEl) {

          countEl.textContent =
            `${total} bottle${total === 1 ? '' : 's'} selected`;

        }



        if (fill) {

          fill.style.width =
            `${Math.min(100, (total / Math.max(goal, 1)) * 100)}%`;

        }



        if (emptyEl) {

          emptyEl.hidden =
            lines.length > 0;

        }



        if (linesEl) {

          linesEl.hidden =
            lines.length === 0;


          linesEl.innerHTML =
            lines.map(([id, qty]) => {

              const product =
                this.products[id];


              if (!product) return '';


              return `
                <li class="nn-builder__line">

                  <img src="${product.image || ''}"
                    alt=""
                    width="56"
                    height="56">

                  <div>
                    <p>${product.title}</p>
                    <span>${money(product.price)}</span>
                  </div>


                  <div class="nn-builder__stepper nn-builder__stepper--sm">

                    <button
                      type="button"
                      data-nn-dec="${id}">
                      −
                    </button>

                    <span>${qty}</span>


                    <button
                      type="button"
                      data-nn-inc="${id}">
                      +
                    </button>

                  </div>


                  <button
                    class="nn-builder__remove"
                    type="button"
                    data-nn-remove="${id}">
                    ×
                  </button>

                </li>
              `;

            }).join('');

        }



        if (subtotalEl) {

          subtotalEl.textContent =
            money(subtotal);

        }



        if (subtotalLabel) {

          subtotalLabel.textContent =
            `Juice subtotal (${total} ${total === 1 ? 'bottle' : 'bottles'})`;

        }



        // Box savings removed


        if (totalEl) {

          totalEl.textContent =
            money(boxPrice);

        }



        if (checkout) {

          checkout.disabled =
            !ready;

        }



        if (minline) {

          minline.textContent =
            `${goal}-bottle box · ${money(boxPrice)}. Pick your flavors below.`;

        }



        if (hint) {

          if (total < 6) {

            hint.textContent =
              `Add ${6 - total} more ${6 - total === 1 ? 'bottle' : 'bottles'} to start your box.`;

          } else {

            hint.textContent =
              'Your box is ready for checkout. Keep adding bottles to build a larger box.';

          }

        }

      }



      async checkout() {

        const checkout =
          this.querySelector('[data-nn-checkout]');


        const items =
          Object.entries(this.state.items)
            .filter(([, qty]) => qty > 0)
            .map(([id, qty]) => ({

              id: Number(id),

              quantity: Number(qty),

              properties: {
                Box:
                  `${this.selectedTier.qty}-bottle custom box`
              }

            }));


        if (!items.length || this.totalQty() < 6) return;



        if (checkout) {

          checkout.disabled = true;

          checkout.textContent =
            'Adding to cart…';

        }



        const cart =
          document.querySelector('cart-drawer') ||
          document.querySelector('cart-notification');


        const payload =
          {
            items
          };


        if (
          cart &&
          typeof cart.getSectionsToRender === 'function'
        ) {

          payload.sections =
            cart.getSectionsToRender()
              .map((section) => section.id);


          payload.sections_url =
            window.location.pathname;

        }



        try {


          const response =
            await fetch(
              window.routes.cart_add_url,
              {

                method: 'POST',

                headers: {
                  'Content-Type':
                    'application/json',

                  Accept:
                    'application/json'
                },


                body:
                  JSON.stringify(payload)

              }
            );


          const data =
            await response.json();



          if (data.status) {

            throw new Error(
              data.description ||
              data.message ||
              'Could not add box'
            );

          }



          const code =
            this.selectedTier.code || '';



          if (code) {

            window.location.href =
              `/discount/${encodeURIComponent(code)}?redirect=/checkout`;

            return;

          }



          if (
            cart &&
            typeof cart.renderContents === 'function' &&
            data.sections
          ) {

            cart.renderContents(data);

          } else if (
            window.routes &&
            window.routes.cart_url
          ) {

            window.location.href =
              window.routes.cart_url;

          }



          sessionStorage.removeItem(
            STORAGE_KEY
          );


          this.state.items = {};

          this.render();



        } catch (err) {


          if (checkout) {

            checkout.textContent =
              'Try again';

          }


          const hint =
            this.querySelector('[data-nn-hint]');


          if (hint) {

            hint.textContent =
              err.message ||
              'Could not add this box. Please try again.';

          }



        } finally {


          if (checkout) {

            checkout.disabled =
              this.totalQty() < 6;


            if (
              checkout.textContent ===
              'Adding to cart…'
            ) {

              checkout.textContent =
                'Continue to cart';

            }

          }

        }

      }

    }
  );

})();